import React from 'react';

export const HistoryIcon: React.FC = () => {
  return (
    <svg width="25" height="21" viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 7L15 12H18C18.5523 12 19 12.4477 19 13C19 13.5523 18.5523 14 18 14H14C13.9655 14 13.9314 13.9983 13.8978 13.9948C13.3935 13.9436 13 13.5178 13 13V7C13 6.44772 13.4477 6 14 6C14.5523 6 15 6.44771 15 7Z"
        fill="#2F353E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.65685 12.1923C5.26633 12.5829 4.63316 12.5829 4.24264 12.1923L0.707107 8.65681C0.316583 8.26629 0.316582 7.63312 0.707107 7.2426C1.09763 6.85208 1.7308 6.85208 2.12132 7.2426L4.94975 10.071L7.77817 7.2426C8.1687 6.85208 8.80186 6.85208 9.19239 7.2426C9.58291 7.63312 9.58291 8.26629 9.19239 8.65681L5.65685 12.1923Z"
        fill="#2F353E"
      />
      <circle cx="15" cy="20" r="1" fill="#2F353E" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 10.5041C23 15.0606 19.4187 18.779 14.92 18.998V21C20.5243 20.7795 25 16.1647 25 10.5041C25 4.70286 20.299 0 14.5 0C8.70101 0 4 4.70286 4 10.5041C4 10.6448 4.00277 10.7849 4.00825 10.9243H6.01019C6.00342 10.7851 6 10.645 6 10.5041C6 5.80669 9.80632 2 14.5 2C19.1937 2 23 5.80669 23 10.5041Z"
        fill="#2F353E"
      />
    </svg>
  );
};
